import { render, staticRenderFns } from "./ClientAddressForm.vue?vue&type=template&id=d49cb522&scoped=true"
import script from "./ClientAddressForm.vue?vue&type=script&lang=ts"
export * from "./ClientAddressForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientAddressForm.vue?vue&type=style&index=0&id=d49cb522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49cb522",
  null
  
)

export default component.exports